import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AppContext } from '../window';
import { NotificationContext } from '../context/NotificationContext';

interface AuthRedirectProps {
    notificationMessage?: string;
}

/**
 * Component that checks if user is logged in and redirects them to /search
 * This should be included in every landing page
 */
const AuthRedirect: React.FC<AuthRedirectProps> = ({ notificationMessage }) => {
    const { user } = useContext(AppContext);
    const { addNotification } = useContext(NotificationContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            // User is logged in, redirect to search
            if (notificationMessage) {
                addNotification({
                    level: 'info',
                    message: notificationMessage,
                    dismissible: true,
                    timeout: 5000
                });
            }
            navigate('/search');
        }
    }, [user]);

    // This component doesn't render anything
    return null;
};

export default AuthRedirect;